import { appConfig } from 'config/appConfig';
import countries from 'constants/countries';

export const getCountry = () => {
  const routeCountry = window?.location?.pathname?.slice(1, 3).toUpperCase();
  return Object.values(countries).some((country) => country === routeCountry) ? routeCountry : null;
};

export const getCountryOrDefault = () => {
  return getCountry() || appConfig.DEFAULT_COUNTRY;
};
